import { render, staticRenderFns } from "./import-substitution-requests-list.vue?vue&type=template&id=502adb95&scoped=true&"
import script from "./import-substitution-requests-list.vue?vue&type=script&lang=js&"
export * from "./import-substitution-requests-list.vue?vue&type=script&lang=js&"
import style0 from "./import-substitution-requests-list.vue?vue&type=style&index=0&id=502adb95&scoped=true&lang=css&"
import style1 from "./import-substitution-requests-list.vue?vue&type=style&index=1&id=502adb95&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502adb95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('502adb95')) {
      api.createRecord('502adb95', component.options)
    } else {
      api.reload('502adb95', component.options)
    }
    module.hot.accept("./import-substitution-requests-list.vue?vue&type=template&id=502adb95&scoped=true&", function () {
      api.rerender('502adb95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/import-substitution/import-substitution-requests-list.vue"
export default component.exports